import { PriceDefault, PriceOld, PriceWrapper } from './Price.styles'
import { useTheme } from '../../lib/hooks'

const Price = ({ children, old }) => {
  const themes = useTheme()
  return (
    <PriceWrapper>
      {old && (
        themes.currency === '€' ? (
          <PriceOld>
            {themes.currency}
            {Number(old).toFixed(2)}
          </PriceOld>
        ) : (
          <PriceOld>
            {Number(old).toFixed(2)}{themes.currency}
          </PriceOld>
        )
      )}
      {themes.currency === '€' ? <PriceDefault $featured={!!old}>
        {themes.currency}
        {Number(children).toFixed(2)}
      </PriceDefault> : <PriceDefault $featured={!!old}>

        {Number(children).toFixed(2)}{themes.currency}
      </PriceDefault>}

    </PriceWrapper>
  )
}

export default Price
